import React from 'react';
import cn from 'classnames';

import s from './PageHeader.module.scss';

interface PageHeaderProps {
  isSticky?: boolean;
  topPadding?: boolean;
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}

export const PageHeader = ({
  isSticky = true,
  topPadding = false,
  left,
  center,
  right,
}: PageHeaderProps): JSX.Element => (
  <div
    className={cn(s.pageHeader, {
      [s.isSticky]: isSticky,
      [s.withPadding]: topPadding,
    })}
  >
    {left && <div className={s.pageHeader__left}>{left}</div>}
    {center && <div className={s.pageHeader__center}>{center}</div>}
    {right && <div className={s.pageHeader__right}>{right}</div>}
  </div>
);
